import countryCodes from './countryPhoneCodes';

const handleCountrySelect = e => {
  const form = e.target.closest('.Form__MainBody');
  const phonePrefix = form.querySelector('.FormPhoneCode__Code');

  if (phonePrefix) {
    const country = e.target.value;
    phonePrefix.value = `+${countryCodes[country]}`;
    phonePrefix.focus();
  }
};

const setupPhoneInput = el => {
  const form = el.querySelector('.Form__MainBody');

  if (!form) return;

  const countrySelect = form.querySelector('.Form__Country select');

  if (!countrySelect) return;

  countrySelect.addEventListener('change', handleCountrySelect);
};

export default setupPhoneInput;
